import { gql } from "@apollo/client";

export const GET_ALL_REQUESTS = gql`
  query GetAllRequests($offset: Int, $limit: Int, $searchType: String, $searchTerm: String) {
    getAllRequests(offset: $offset, limit: $limit, searchType: $searchType, searchTerm: $searchTerm) {
      success
      count
      error
      data {
        kyc_id
        vin
        imei
        engine_number
        year
        vehicle_make
        vehicle_model
        fuel_type
        customer_name
        customer_mobile
        retail_invoice_number
        customer_address
        customer_email
        dealer_code
        dealer_name
        dealer_address
        dealer_town
        dealer_contact_name
        kyc_count
        kyc_approved_date
        kyc_rejected_date
        last_kyc_recieved_date
        kyc_mode
        proof_of_address
        proof_of_identity
        ticket_created
        status
        rejection_reason
        request_id
        project_name
        device_model
        device_serial_number
        device_imei_number
        iccid_number
        customer_number
        customer_otp_number
        registration_state
        rto_name
        rto_number
        dealer_contact_number
        alternate_dealer_name
        alternate_dealer_number
        sim_activation_status
        msisdn_1
        msisdn_2
        vehicle_type
        year_of_manufacture
        comman_layer_cert
        common_layer_cert_issued_date
        fitment_cert
        fitment_cert_issued_date
      }
    }
  }
`;

export const UPLOAD_PDF_MUTATION = gql`
  mutation UploadPdf($pdf: Upload!) {
    uploadPdf(pdf: $pdf) {
      success
      url
      filename
      error
      originalName
      size
      mimetype
    }
  }
`;

export const UPLOAD_CERTIFICATE_MUTATION = gql`
  mutation UploadCertificate($input: CertificateUploadInput!) {
    uploadCertificate(input: $input) {
      success
      message
      error
    }
  }
`;